import { render, staticRenderFns } from "./NotifyEmail.vue?vue&type=template&id=be5059f4"
import script from "./NotifyEmail.vue?vue&type=script&lang=js"
export * from "./NotifyEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports